import Env from './env';
import cookie from './cookie';

export default (() => {
  if (Env.env !== 'live' || cookie.get('csc-debug') === '1') {
    return console.log.bind(window.console);
  }
  return () => {};
})();



// WEBPACK FOOTER //
// ./src/utils/log.js